import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const params = new URLSearchParams(hash.replace('#', '?'));
    const sessionId = params.get('session_id');
    const returnPath = window.location.pathname || '/calculator';

    if (!sessionId) { navigate('/', { replace: true }); return; }

    const processSession = async (retries = 4) => {
      try {
        const res = await fetch(`${API}/auth/session`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ session_id: sessionId }),
        });
        if (res.ok) {
          const data = await res.json();
          setUser(data.user);
          navigate(returnPath, { replace: true });
        } else if (retries > 0) {
          // Auth server may need a moment to propagate the session — retry
          setTimeout(() => processSession(retries - 1), 1500);
        } else {
          navigate('/', { replace: true });
        }
      } catch {
        if (retries > 0) {
          setTimeout(() => processSession(retries - 1), 1500);
        } else {
          navigate('/', { replace: true });
        }
      }
    };

    processSession();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-zinc-50 flex items-center justify-center">
      <div className="text-center px-6">
        <div className="font-bebas text-4xl text-zinc-950 uppercase tracking-widest mb-4 animate-pulse">
          Authenticating
        </div>
        <div className="flex gap-1.5 justify-center mb-4">
          {[0, 1, 2].map(i => (
            <div key={i} className="w-2 h-2 bg-zinc-950 animate-bounce" style={{ animationDelay: `${i * 150}ms` }} />
          ))}
        </div>
        <p className="text-zinc-400 text-xs uppercase tracking-widest font-semibold">Processing your Premium credentials</p>
      </div>
    </div>
  );
}
